import * as React from "react";
import { cn } from "../cn";

export interface CallsignProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Visual treatment: panel-style chip or bare inline */
  variant?: "chip" | "inline";
}

/**
 * Displays a callsign, frequency, fix name, or document reference in
 * uppercase mono with widened tracking — e.g. JO 7110.65BB, 121.5,
 * AAL2429, ATIS BRAVO.
 */
export const Callsign = React.forwardRef<HTMLSpanElement, CallsignProps>(
  ({ className, variant = "inline", ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "text-callsign",
        variant === "chip" && [
          "inline-flex items-center px-1.5 py-0.5",
          "border border-[var(--color-panel-edge)] rounded-[var(--radius-sm)]",
          "bg-[var(--color-panel-raised)] text-[var(--color-amber-bright)]",
        ],
        className,
      )}
      {...props}
    />
  ),
);
Callsign.displayName = "Callsign";
